
import React from 'react';

const Solutions: React.FC = () => {
  const solutions = [
    {
      title: 'Service Management Orchestration',
      description: 'Integrate one or many ITSM platforms with communication tools, monitoring systems, and self-healing AI Agents.',
      features: [
        'ITSM Platform Integration',
        'Incident Management Automation',
        'Service Request Processing',
        'Real-time Monitoring'
      ],
      image: 'https://public.readdy.ai/ai/img_res/63cc31b8b55313bb4f13241c30c04f1f.jpg'
    },
    {
      title: 'Customer Experience Orchestration',
      description: 'Give your customers real choice and enable automated service via WhatsApp, Teams, Slack and more.',
      features: [
        'Multi-Channel Communication',
        'WhatsApp Integration',
        'Teams & Slack Automation',
        'Customer Self-Service'
      ],
      image: 'https://readdy.ai/api/search-image?query=customer%20service%20communication%20channels%20including%20WhatsApp%2C%20Teams%2C%20Slack%20icons%20connected%20in%20a%20network%2C%20modern%20customer%20experience%20design&width=600&height=400&seq=customer&orientation=landscape'
    },
    {
      title: 'Business Technology Orchestration',
      description: 'Enable end-to-end automation of IT Operations Management, System Management, Discovery, DevOps, and monitoring systems.',
      features: [
        'DevOps Integration',
        'System Discovery',
        'CMDB Reconciliation',
        'Event Management'
      ],
      image: 'https://readdy.ai/api/search-image?query=business%20technology%20infrastructure%20with%20servers%2C%20databases%2C%20cloud%20services%2C%20and%20monitoring%20systems%20interconnected%2C%20enterprise%20IT%20architecture&width=600&height=400&seq=business-tech&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Comprehensive Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From service management to customer experience and business technology orchestration, we provide end-to-end automation solutions.
          </p>
        </div>

        <div className="space-y-20">
          {solutions.map((solution, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="lg:w-1/2">
                <img 
                  src={solution.image} 
                  alt={solution.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h3 className="text-3xl font-bold text-gray-900 mb-6">{solution.title}</h3>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">{solution.description}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {solution.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <i className="ri-check-line text-blue-600 mr-3 text-xl"></i>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
